enum FccOrderSkuRoutes {
  List = '/fcc-orders-sku',
}

export default FccOrderSkuRoutes
